import clsx from 'clsx'
import { RepoCard } from './RepoCard'
import { Unstables } from './Unstables'
import { SecurityAlerts } from './SecurityAlerts'
import { AwsSecurityFindings } from './AwsSecurityFindings'
import { RepoMap } from '../types'

export const Monitor = ({ repoWorkflows }: { repoWorkflows: RepoMap }) => {
  return (
    <div>
      <Unstables repoWorkflows={repoWorkflows} />
      <SecurityAlerts />
      <AwsSecurityFindings />

      <div className="text-lg font-mono w-full mt-8">All repositories</div>

      <ul className={clsx('flex flex-row gap-2 flex-wrap', 'mt-4')}>
        {Object.values(repoWorkflows)
          .toSorted((repo) =>
            Object.values(repo.workflows).some(
              (wf) => wf.latestRun?.conclusion === 'failure',
            )
              ? -1
              : 1,
          )
          .map((repo) => (
            <RepoCard key={repo.name} repo={repo} />
          ))}
      </ul>
    </div>
  )
}
